export default "__VITE_ASSET__Ct7Qqqcv__"